export default function Thoughts() {
  return (
    <table
      width="100%"
      height="100%"
      border="0"
      align="center"
      cellpadding="0"
      cellspacing="0"
    >
      <tr align="center" valign="bottom">
        <td height="30" colspan="2">
          <a class="1" href="/">
            return to main page
          </a>
        </td>
      </tr>
      <tr align="center" valign="middle">
        <td>
          <a href="?i=anime">
            <img
              src="/assets/i/anime.png"
              alt="anime"
              name="png"
              width="120"
              height="120"
              border="0"
              id="png"
            />
            <br />
            anime
          </a>
        </td>
        <td>
          <a href="?i=movies">
            <img
              src="/assets/i/movies.png"
              alt="movies"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            movies
          </a>
        </td>
      </tr>
      <tr align="center" valign="middle">
        <td>
          <a href="?i=music">
            <img
              src="/assets/i/music.png"
              alt="music"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            music
          </a>
        </td>
        <td>
          <a href="?i=games">
            <img
              src="/assets/i/games.png"
              alt="games"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            games
          </a>
        </td>
      </tr>
      <tr align="center" valign="middle">
        <td colspan="2">
          <a href="?i=misc">
            <img
              src="/assets/i/misc.png"
              alt="miscelaneous"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            miscelaneous
          </a>
        </td>
      </tr>
    </table>
  );
}
